import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { asyncConnect } from 'redux-connect';
import ApplyCSS from '../../../components/ApplyCSS';
import * as labelsActions from '../../../components/labels/actions';
import commonUtil from '../../../utils/commonUtil';
import { _handleUserRegistration } from './actions';
import RegistrationBenefits from './components/registrationBenefits';
import SignUp from './components/signUp';
import SignUpWap from './components/signUpWap';
import Warning from './../../../components/Warning';


const { isLablesLoaded, loadLables } = labelsActions;
const channel = commonUtil.getChannel().toUpperCase();

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  user: store.user,
}),
  { ...labelsActions })

class CreateCoOWnerAccount extends Component {
  constructor() {
    super();
    this.warningMessage = null;
  }

  componentWillReceiveProps(nextProps) {
    const user = nextProps.user.data;
    if (user && !nextProps.user.loading && user.result && user.result.status && user.result.status.status === 'success') {
      this.warning.setMessage('');
    } else if (user && !nextProps.user.loading && user.result && user.result.status && user.result.status.status === 'failure' && user.result.status.errorCode === '002') {
      this.warning.setMessage(user.result.status.errorMessage);
    }
  }
  render() {
    const pageName = 'createCoOnwerAccount';
    const lables = this.props.lables;
    return (
      <React.Fragment>
        {channel === 'WAP' && <div>
          <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
          <SignUpWap _handleUserRegistration={this.props._handleUserRegistration} lables={lables} />
        </div>}
        { channel === 'WEB' &&
        <div className="container wrap">
          <ApplyCSS pageName={pageName} />
          <div className="row contentAccountAdd">
            <div className="col-md-12 col-sm-12">
              <h3 className="text-center">{commonUtil.getLabel(lables.createLogin, 'createAccount.Register.message')}</h3>
              <p className="mainTextSecond text-center">{commonUtil.getLabel(lables.createLogin, 'createAccount.register.account.message')}</p>
            </div>
            <div>
              <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
            </div>
            <RegistrationBenefits />
            <SignUp _handleUserRegistration={this.props._handleUserRegistration} lables={lables} />
          </div>
        </div> }
      </React.Fragment>
    );
  }
}
const matchDispatchToProps = dispatch => bindActionCreators({ _handleUserRegistration }, dispatch);
export default connect(null, matchDispatchToProps)(CreateCoOWnerAccount);
